<div class="calculator__left">
  <div>
    <div class="calculator__left-top">
      <div class="calculator__left-title">Отправитель</div>
    </div>
    <el-form-item prop="sender.senderType">
      <el-form-item prop="dataForm.sender.senderType">
        <el-radio-group
          class="calculator__payer__buttons calculator__payer__buttons_type_three mb-40"
          v-model="dataForm.sender.senderType"
          @change="senderTypeChange"
        >
          <el-radio-button
            v-for="option in optionsPersonType"
            :key="option.value"
            :label="option.value"
            class="calculator__payer__button"
            @click="e => e.target.parentNode.classList.remove('is-focus')"
          >{{ option.label }}</el-radio-button>
        </el-radio-group>
      </el-form-item>
    </el-form-item>

    <el-form-item v-if="dataForm.sender.senderType" class="calculator__form-inner" >
      <el-form-item
        prop="sender.innSender"
        class="calculator__form-item"
      >
        <el-input :placeholder="dataForm.sender.senderType === 2 ? 'ИНН/БИН' : 'ИНН'" type="text" autocomplete="on" v-model="dataForm.sender.innSender" v-mask="INN_MASK" :maxlength="dataForm.sender.senderType === 2 ? 12 : 10" @change="getNameOrganization('sender', dataForm.sender.innSender)" />
      </el-form-item>

      <el-form-item
        v-if="dataForm.sender.senderType == 1"
        prop="sender.kppSender"
        class="calculator__form-item"
      >
        <el-input placeholder="КПП" type="text" autocomplete="on" v-model="dataForm.sender.kppSender" v-mask="KPP_MASK" @change="getNameOrganization('sender', dataForm.sender.kppSender)" />
      </el-form-item>

      <el-form-item
        prop="sender.name"
        class="calculator__form-item"
      >
        <el-input placeholder="Наименование организации" type="text" autocomplete="on" v-model="dataForm.sender.name" />
      </el-form-item>
    </el-form-item>

    <el-form-item v-if="!dataForm.sender.senderType" class="calculator__form-inner" >

        <el-form-item prop="sender.surnameSender" class="calculator__form-item margin-bottom--30-p">
          <el-autocomplete
            :fetch-suggestions="getSurNameSearch"
            @input="getSurName"
            clearable
            placeholder="Фамилия"
            :trigger-on-focus="false"
            v-model="dataForm.sender.surnameSender"
            @keyup="dataForm.sender.surnameSender = limitInput(dataForm.sender.surnameSender)"
          />
        </el-form-item>

        <el-form-item prop="sender.firstNameSender" class="calculator__form-item margin-bottom--30-p">
          <el-autocomplete
            v-model="dataForm.sender.firstNameSender"
            @keyup="dataForm.sender.firstNameSender = limitInput(dataForm.sender.firstNameSender)"
            :fetch-suggestions="getFirstNameSearch"
            @input="getName"
            clearable
            placeholder="Имя"
            :trigger-on-focus="false"
          />
        </el-form-item>

        <el-form-item prop="sender.secondNameSender" class="calculator__form-item margin-bottom--30-p">
          <el-autocomplete
          v-model="dataForm.sender.secondNameSender"
          @keyup="dataForm.sender.secondNameSender = limitInput(dataForm.sender.secondNameSender)"
            :fetch-suggestions="getSecondNameSearch"
            @input="getSecondName"
            clearable
            placeholder="Отчество"
            autocomplete="additional-name"
            :trigger-on-focus="false"
          />
        </el-form-item>

    </el-form-item>

    <el-form-item class="form-group"> 

          <el-form-item
            prop="sender.phoneSender"
            class="calculator__form-item"
            label="Телефон"
          >
            <el-input
              v-model="dataForm.sender.phoneSender"
              v-mask="PHONE_MASK"
              type="tel"
              :formatter="(value) => `${value}`.replace(/\(89/g, '9')"
              :placeholder="PHONE_PLACEHOLDER"
              @change="checkPhone"
            />
          </el-form-item>

          <el-form-item
            prop="sender.emailSender"
            :required="dataForm.sender.senderType"
            class="calculator__form-item"
            label="Эл. почта"
          >
            <el-input type="email" autocomplete="email" v-model="dataForm.sender.emailSender" />
          </el-form-item>

    </el-form-item>
  </div>

  <div class="container_button">
    <el-form-item>
      <!-- <router-link to="/calculator" class="button-link">
        <el-button 
          class="button_shadow"
          type="primary"
        > 
          Калькулятор
        </el-button>
      </router-link> -->
    </el-form-item>
    <el-form-item>
      <!-- <el-button
        class="button_send"
        type="primary"
        @click="$emit('click-button-next')"
        >
        Далее
      </el-button> -->
    </el-form-item>
  </div>
</div>
<div class="calculator__center-line"></div>